<template>
    <div class="chat-announcement">
        <div class="announcement-bar" @click="openDialog">
            <div class="title">
                <i class="el-icon-bell"></i>
                <span>群内公告</span>
            </div>
            <div class="marquee-container">
                <div class="marquee-wrapper" ref="marqueeWrapper">
                    <div class="marquee-content" ref="marqueeContent" v-html="contentHtml"></div>
                    <div v-if="needScroll" class="marquee-content marquee-copy" v-html="contentHtml"></div>
                </div>
            </div>
            <div class="view-full">查看</div>
        </div>

        <el-dialog title="群内公告" :visible.sync="dialogVisible" width="520px" append-to-body>
            <div class="announcement-dialog-content" v-html="contentHtml"></div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">知道了</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "chatAnnouncement",
    props: {
        group: {
            type: Object
        },
        announcementInfo: {
            type: [Object, String],
            default: '',
            required: true
        },
        scrollSpeed: {
            type: Number,
            default: 50
        }
    },
    data() {
        return {
            dialogVisible: false,
            needScroll: false,
            resizeTimer: null,
            measureFrame: null
        }
    },
    methods: {
        openDialog() {
            this.dialogVisible = true;
        },
        handleResize() {
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(this.scheduleMarqueeMeasure, 120);
        },
        scheduleMarqueeMeasure() {
            if (this.measureFrame) {
                cancelAnimationFrame(this.measureFrame);
            }
            this.measureFrame = requestAnimationFrame(() => {
                this.measureFrame = null;
                this.setupMarqueeAnimation();
            });
        },
        setupMarqueeAnimation() {
            const container = this.$el && this.$el.querySelector('.marquee-container');
            const wrapper = this.$refs.marqueeWrapper;
            const content = this.$refs.marqueeContent;
            if (!container || !wrapper || !content) return;

            const containerWidth = container.clientWidth;
            const contentWidth = content.scrollWidth;
            const shouldScroll = contentWidth > containerWidth;

            if (this.needScroll !== shouldScroll) {
                this.needScroll = shouldScroll;
            }

            wrapper.style.transform = 'translateX(0)';
            if (shouldScroll) {
                const duration = Math.max(10, Math.ceil((contentWidth + containerWidth) / this.scrollSpeed));
                wrapper.style.animationDuration = `${duration}s`;
                wrapper.style.animationPlayState = 'running';
            } else {
                wrapper.style.animationDuration = '';
                wrapper.style.animationPlayState = 'paused';
            }
        }
    },
    mounted() {
        this.$nextTick(this.scheduleMarqueeMeasure);
        window.addEventListener('resize', this.handleResize);
    },
    watch: {
        contentHtml() {
            this.needScroll = false;
            this.$nextTick(this.scheduleMarqueeMeasure);
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
        clearTimeout(this.resizeTimer);
        if (this.measureFrame) {
            cancelAnimationFrame(this.measureFrame);
        }
    },
    computed: {
        contentHtml() {
            if (!this.announcementInfo) {
                return "暂无公告";
            }

            let announcementContent = '';
            if (typeof this.announcementInfo === 'string') {
                announcementContent = this.announcementInfo;
            } else if (this.announcementInfo && this.announcementInfo.content) {
                announcementContent = this.announcementInfo.content;
            }

            return this.$emo.transform(this.$str.html2Escape(announcementContent), 'emoji-normal');
        }
    }
}
</script>

<style scoped lang="scss">
.chat-announcement {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    height: 42px;
    flex: 0 0 42px;
    position: relative;
    z-index: 2;
    box-sizing: border-box;
    overflow: hidden;

    .announcement-bar {
        width: 100%;
        height: 42px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 0 16px;
        overflow: hidden;
        cursor: pointer;
        background: linear-gradient(90deg, #fff7dd 0%, #fff2c5 52%, #fff8e7 100%);
        border-bottom: 1px solid rgba(214, 154, 32, 0.18);
        box-shadow: 0 2px 8px rgba(154, 114, 28, 0.08);
    }

    .title {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: var(--im-font-size);
        font-weight: 600;
        color: #8a5d00;
        flex-shrink: 0;
        white-space: nowrap;
    }

    .view-full {
        flex-shrink: 0;
        padding: 2px 8px;
        border-radius: 999px;
        color: #9a6400;
        background: rgba(255, 255, 255, 0.6);
        font-size: var(--im-font-size-smaller);
    }

    .marquee-container {
        flex: 1;
        min-width: 0;
        height: 28px;
        overflow: hidden;
        position: relative;
    }

    .marquee-wrapper {
        display: flex;
        align-items: center;
        width: max-content;
        min-width: 100%;
        max-width: none;
        height: 100%;
        animation-name: announcement-marquee;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
        animation-play-state: paused;
        will-change: transform;
    }

    .marquee-content {
        display: inline-block;
        padding-right: 56px;
        font-size: var(--im-font-size);
        color: #6f520f;
        white-space: nowrap;
        line-height: 28px;
        flex-shrink: 0;
    }

    .marquee-copy {
        padding-left: 0;
    }
}

.announcement-dialog-content {
    max-height: 56vh;
    overflow-y: auto;
    padding: 4px 2px;
    color: var(--im-text-color-primary);
    font-size: var(--im-font-size);
    line-height: 1.7;
    white-space: pre-wrap;
    word-break: break-word;
}

.dialog-footer {
    text-align: right;
}

@keyframes announcement-marquee {
    0% {
        transform: translateX(0);
    }

    100% {
        transform: translateX(-50%);
    }
}
</style>
